import { render, staticRenderFns } from "./r-select-old.vue?vue&type=template&id=24abd4dc&scoped=true"
import script from "./r-select-old.vue?vue&type=script&lang=js"
export * from "./r-select-old.vue?vue&type=script&lang=js"
import style0 from "./r-select-old.vue?vue&type=style&index=0&id=24abd4dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24abd4dc",
  null
  
)

export default component.exports